import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateTask } from '../api';
import type { UpdateJobTaskInput } from '@maker-toolchest/shared';

export function useUpdateTask(jobId: string, taskId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateJobTaskInput) => updateTask(jobId, taskId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['jobs'] });
      queryClient.invalidateQueries({ queryKey: ['job', jobId] });
      queryClient.invalidateQueries({ queryKey: ['task', jobId, taskId] });
    },
  });
}
